class BdCardVariants extends HTMLElement {
  connectedCallback() {
    const script = this.querySelector('[data-variants]');
    if (!script) return;

    try {
      this.variants = JSON.parse(script.textContent);
    } catch (e) {
      console.error('bd-card-variants: invalid variants JSON', e);
      return;
    }

    this.selects = this.querySelectorAll('.bd__upsell-item__select');

    // The form lives in a sibling .card__content, not inside this element
    const wrapper = this.closest('.card-wrapper');
    if (!wrapper) return;

    const formId = this.dataset.formId;
    this.form = formId ? wrapper.querySelector(`#${formId}`) : wrapper.querySelector('form[data-type="add-to-cart-form"]');
    if (!this.form) return;

    this.variantInput = this.form.querySelector('input.product-variant-id');
    this.submitButton = this.form.querySelector('.quick-add__submit');
    this.priceEl = wrapper.querySelector('.price'); // optional

    this.selects.forEach((select) => {
      select.addEventListener('change', () => this.onChange());
    });
  }

  onChange() {
    const selected = Array.from(this.selects).map((s) => s.value);
    const variant = this.variants.find((v) =>
      selected.every((val, i) => v.options[i] === val)
    );

    if (!variant) {
      // Combination doesn't exist — disable add
      this.setUnavailable();
      return;
    }

    // 1. Write the variant id into the hidden input that Dawn's form submits
    if (this.variantInput) {
      this.variantInput.value = variant.id;
      // Dawn disables the hidden input when variant is unavailable; keep in sync
      this.variantInput.disabled = !variant.available;
    }

    // 2. Toggle the submit button
    if (this.submitButton) {
      this.submitButton.disabled = !variant.available;
      this.submitButton.setAttribute(
        'aria-label',
        variant.available
          ? `Add ${variant.name} to cart`
          : 'Unavailable'
      );
    }

    // 3. Optional: refresh price display
    this.updatePrice(variant);
  }

  setUnavailable() {
    if (this.variantInput) {
      this.variantInput.value = '';
      this.variantInput.disabled = true;
    }
    if (this.submitButton) {
      this.submitButton.disabled = true;
    }
  }

  updatePrice(variant) {
    if (!this.priceEl) return;

    const regularPriceEl = this.priceEl.querySelector('.price-item--regular');
    if (regularPriceEl && window.Shopify?.formatMoney) {
      regularPriceEl.textContent = Shopify.formatMoney(variant.price);
    }

    // Toggle sale class
    this.priceEl.classList.toggle(
      'price--on-sale',
      variant.compare_at_price && variant.compare_at_price > variant.price
    );
    this.priceEl.classList.toggle('price--sold-out', !variant.available);
  }
}

if (!customElements.get('bd-card-variants')) {
  customElements.define('bd-card-variants', BdCardVariants);
}